import { useState } from "react";

export const useGorgiasSubmit = (
  username,
  apiKey,
  endpoint = "https://zeroco.gorgias.com/api/tickets",
) => {
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);
  const [success, setSuccess] = useState(false);

  const submitForm = async (formData) => {
    setIsLoading(true);
    setError(null);
    setSuccess(false);

    const ticketData = {
      customer: {
        email: formData.email,
        name: formData.name,
      },
      subject: `New Contact Us Submission from ${formData.name}`,
      messages: [
        {
          channel: "api",
          via: "api",
          from_agent: false,
          sender: {
            email: formData.email,
            name: formData.name,
          },
          body_text: formData.message,
        },
      ],
      tags: [{ name: "test-mindarc" }],
      status: "open",
      via: "api",
    };

    console.log("Gorgias SUBMISSION", ticketData);

    try {
      const response = await fetch(endpoint, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Basic ${btoa(username + ":" + apiKey)}`,
        },
        body: JSON.stringify(ticketData),
      });

      if (response.ok) {
        setSuccess(true);
        setError(null);
      } else {
        setSuccess(false);
        const errorMsg = await response.text();
        setError(`Failed to submit the form: ${errorMsg}`);
      }
    } catch (error) {
      setError(`An error occurred: ${error.message}`);
      setSuccess(false);
    } finally {
      setIsLoading(false);
    }
  };

  return {
    isLoading,
    error,
    success,
    submitForm,
  };
};
